import PropTypes from 'prop-types';
import {
    createContext,
    useEffect,
    useRef,
} from 'react';
import { http } from '../helpers';
import {
    createViewerBinaryCache,
    DEFAULT_VIEWER_BINARY_CACHE_MAX_IDLE_MS,
    DEFAULT_VIEWER_BINARY_CACHE_MAX_BYTES,
} from '../helpers/viewerBinaryCache';

const ViewerBinaryCacheContext = createContext(null);

function ViewerBinaryCacheProvider({
    children,
    fetchBinary,
    maxIdleMs,
    maxBytes,
}) {
    const cacheRef = useRef(null);

    if (!cacheRef.current) {
        cacheRef.current = createViewerBinaryCache({
            fetchBinary,
            maxIdleMs,
            maxBytes,
        });
    }

    useEffect(() => () => {
        cacheRef.current?.clear();
    }, []);

    return (
        <ViewerBinaryCacheContext.Provider value={cacheRef.current}>
            {children}
        </ViewerBinaryCacheContext.Provider>
    );
}

ViewerBinaryCacheProvider.propTypes = {
    children: PropTypes.node.isRequired,
    fetchBinary: PropTypes.func,
    maxIdleMs: PropTypes.number,
    maxBytes: PropTypes.number,
};

ViewerBinaryCacheProvider.defaultProps = {
    fetchBinary: http.getBlob,
    maxIdleMs: DEFAULT_VIEWER_BINARY_CACHE_MAX_IDLE_MS,
    maxBytes: DEFAULT_VIEWER_BINARY_CACHE_MAX_BYTES,
};

export {
    ViewerBinaryCacheContext,
    ViewerBinaryCacheProvider,
};
